import React, { FC, MouseEvent, useMemo } from "react"
import { ReactComponent as PauseIcon } from "icons/lib/pause.svg"
import { ReactComponent as PlayIcon } from "icons/lib/play.svg"
import { ReactComponent as IconSpinner } from "icons/lib/spinner.svg"

interface AIModelActivenessToggleButtonProps {
    size: "sm" | "md"
    className?: string
    isActive: boolean
    isProcessing: boolean
    onClick?: () => void
}

export const AIModelActivenessToggleButton: FC<AIModelActivenessToggleButtonProps> =
    ({ size, className, isActive, isProcessing, onClick }) => {
        const handleChangeActiveness = useMemo(
            () =>
                onClick === undefined
                    ? undefined
                    : (e: MouseEvent) => {
                          e.stopPropagation()
                          onClick()
                      },
            [onClick]
        )
        const iconClassName = size === "sm" ? "w-3 h-3" : "w-h h-4"

        return (
            <button
                data-testid={isActive ? "pause-model" : "resume-model"}
                className={className}
                disabled={isProcessing || handleChangeActiveness === undefined}
                onClick={handleChangeActiveness}
            >
                {isProcessing ? (
                    <IconSpinner className={iconClassName} />
                ) : isActive ? (
                    <PauseIcon className={iconClassName} />
                ) : (
                    <PlayIcon className={iconClassName} />
                )}
                <span className="sr-only">
                    {isActive ? "Pause model" : "Resume model"}
                </span>
            </button>
        )
    }
